'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './dictionaries.routes';
import list from './list';
import edit from './edit';
import add from './add';

export default angular.module('updateServerApp.dictionaries', [uiRouter, list, edit, add])
  .config(routing)
  .run(function ($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
      if (next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/dictionaries/index.js